import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import Parameter from "../pages/Parameter";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Configuration,
    key: "Parameter",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={null}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <Parameter />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
